import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

import {
  Row,
  Col,
  Button,
  Badge,
} from 'react-bootstrap';
import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Tooltip } from "antd";

// Auth
// import { useAuthContext } from '../../../../v5/auth/use-auth-context.js';
// import { useRouter } from '../../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../v5/utils/store.tsx';
import slice, { useFormikContext, isEdit, isCopy, checkStatus } from '../slice.tsx';
import { proformaInvoiceHeaderStatusText } from './proformaInvoice/slice.tsx';

// enums
// import { isNumeric } from '../../../../v5/utils/utils.tsx';
import { ProformaInvoiceStatus } from '../../../../v5/utils/enums.tsx';

// components
// import MainContainer from '../../../../v5/components/container/MainContainer.jsx';

import { ReactComponent as XIcon } from "../../../../v5/assets/icons/smallX.svg";

// ----------------------------------------------------------------------

const StyledButton: React.FC<React.ComponentProps<typeof Button>> = styled(Button)`
  line-height: 14px;
  padding: 5px;

  svg {
    path {
      stroke: var(--bs-gray-700);
    }
  }
`;

const StyledBadge: React.FC<React.ComponentProps<typeof Badge>> = styled(Badge)`
    border-radius: 4px !important;
    padding: 2px 8px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    line-height: 18px !important;

    color: white;
    background-color: var(--bs-gray-500);
    border: 1px solid var(--bs-gray-500);

    ${(props: any) => {
      if(props.status === ProformaInvoiceStatus.Sent){
          return `
            background-color: var(--bs-yellow-500) !important;
            border: 1px solid var(--bs-yellow-500) !important;
          `
      } else if(props.status === ProformaInvoiceStatus.Accepted){
          return `
            background-color: #8908B7 !important;
            border: 1px solid #8908B7 !important;
          `
      } else if(props.status === ProformaInvoiceStatus.Declined){
          return `
            background-color: var(--bs-red-500) !important;
            border: 1px solid var(--bs-red-500) !important;
          `
      } else if(props.status === ProformaInvoiceStatus.Paid){
          return `
            background-color: var(--bs-green-500) !important;
            border: 1px solid var(--bs-green-500) !important;
          `
      } else {
        if(props?.proformaInvoice != ''){
          return `
            background-color: var(--bs-yellow-500) !important;
            border: 1px solid var(--bs-yellow-500) !important;
          `
        } else {
          return `
            background-color: var(--bs-gray-500) !important;
            border: 1px solid var(--bs-gray-500) !important;
          `
        }
      }
    }}
`;


const Header = (props: any) => {
  // const location = useLocation();
  // const router = useRouter();
  
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();

  // const {  } = useTypedSelector((state: RootState) => state.jobFormSlice);
  // const dispatch = useDispatch<AppDispatch>();

  let proformaTag = proformaInvoiceHeaderStatusText(values, false);

  let billingProfile = (values && values.customer && values.customer.billingProfile) ? values.customer.billingProfile : null;
  let isConnectQuickbook = (billingProfile && billingProfile.isConnectQuickbook) ? billingProfile.isConnectQuickbook : false;
  let isConnectXero = (billingProfile && billingProfile.isConnectXero) ? billingProfile.isConnectXero : false;

  return <>
    <Row className='g-12 align-items-center'>
      <Col xs={'auto'}>
        <h6 className="medium mb-0 me-12">{isEdit() ? isCopy() ? 'Copy Job' : values?.jobNumber : 'Create New Job'}</h6>
      </Col>
      <Col xs={'auto'}>
        <Tooltip overlayClassName='dark' title={'Job status'}>
          <Badge bg={'custom-' + values.statusName.toLowerCase().trim().replaceAll(' ', '')}>{values.statusName}</Badge>
        </Tooltip>
      </Col>
      {isConnectQuickbook && <Col xs={'auto'}>
        <Tooltip overlayClassName='dark' title={'Billing profile is connected to Quickbook'}>
          <Badge bg={'custom-border-info'}>Quickbook</Badge>
        </Tooltip>
      </Col>}
      {isConnectXero && <Col xs={'auto'}>
        <Tooltip overlayClassName='dark' title={'Billing profile is connected to Xero'}>
          <Badge bg={'custom-border-info'}>Xero</Badge>
        </Tooltip>
      </Col>}
      {values?.jobTemplate && <Col xs={'auto'}>
        <Tooltip overlayClassName='dark' title={values?.isBillable ? 'This job is Billable' : 'This job is Non-Billable'}>
          <StyledBadge bg={values?.isBillable ? 'custom-border-primary' : 'custom-border-danger'}>{values?.isBillable ? 'Billable' : 'Non-Billable'}</StyledBadge>
        </Tooltip>
      </Col>}
      {(isEdit() && !isCopy() && proformaTag != '') && <Col xs={'auto'}>
        <Tooltip overlayClassName='dark' title={'Proforma invoice status'}>
          {(values && values?.proformaInvoiceNumber && values?.proformaInvoiceNumber != '') && <StyledBadge bg={'custom'} status={values.proformaInvoiceStatus} proformaInvoice={values?.proformaInvoice}>{proformaTag}</StyledBadge>}
        </Tooltip>
      </Col>}
      {(isEdit() && (values?.proformaInvoiceStatus === ProformaInvoiceStatus.Sent) && checkStatus(values?.statusName, ['assigned'])) && <Col xs={'auto'}>
        <Tooltip overlayClassName='dark' title={'Proforma invoice is not yet accepted'}>
          <Badge bg={'custom-border-warning'}>Proforma not accepted</Badge>
        </Tooltip>
      </Col>}
      
      <Col xs={true} className='text-end'>
        <StyledButton
          variant={'custom-outlined'}
          onClick={(e: any) => {
            e.stopPropagation();
            e.preventDefault();
            
            if(props.onCancel){
              props.onCancel();
            }
          }}
        >
          <XIcon />
        </StyledButton>
      </Col>
    </Row>
  </>
}

export default Header;
